import { GalleryComponent } from './update-business/gallery/gallery.component'

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { businessesRoutes } from './businesses.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { BusinessesComponent } from './businesses.component'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { UpdateBusinessComponent } from './update-business/update-business.component'
import { RadioModule } from '@components/radio/radio.module'
import { GeneralComponent } from './update-business/general/general.component'
import { GeneralComponent as CreateGeneralComponent } from './create-business/general/general.component'
import { DocumentsComponent } from './update-business/documents/documents.component'
import { PaymentsComponent } from './update-business/payments/payments.component'
import { PaymentCardModule } from '@components/payment-card/payment-card.module'
import { ReactiveFormsModule } from '@angular/forms'
import { CreateBusinessComponent } from './create-business/create-business.component'
import { ContentLoadingModule } from '@components/content-loading/content-loading.module'
import { PropertyPhotoGalleryModule } from '@components/property-photo-gallery/property-photo-gallery.module'
import { LngLatFieldsModule } from '@components/lng-lat-fields/lng-lat-fields.module'
import { PanelModule } from '@components/panel/panel.module'

@NgModule({
  declarations: [
    BusinessesComponent,
    UpdateBusinessComponent,
    CreateBusinessComponent,
    GeneralComponent,
    DocumentsComponent,
    CreateGeneralComponent,
    PaymentsComponent,
    GalleryComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(businessesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    RadioModule,
    PaymentCardModule,
    ReactiveFormsModule,
    ContentLoadingModule,
    PropertyPhotoGalleryModule,
    ContentEditableModule,
    LngLatFieldsModule,
  ],
})
export class BusinessesModule {}
